import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {IFeatureData} from "../server/IData";
import {Symbol, XBombStates} from "../reels/Symbol";
import {Sound} from "../sound/Sound";

export class XBombRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.xBombData.length > 0 && (Game.model.gameData.win === 0 || (Game.model.gameData.brokeTheBank && !Game.model.gameData.suspendedAction)) && !Game.model.gameData.maxExpansion && Game.model.canXBombTrigger();
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const featureTl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            xBombs: IFeatureData[] = Game.model.xBombData;

        featureTl.add(() => {
            controller.setSkipCallback(() => {
                this.skip(featureTl);
            });
        });

        featureTl.to(this, {
            duration: 0.1
        });

        xBombs.forEach((xBomb: IFeatureData, idx: number) => {
            const tl: gsap.core.Timeline = gsap.timeline(),
                xBombSymbol: Symbol = Game.reelsView.reelModels[xBomb.reelId].getSymbolAt(xBomb.rowId, "XB");

            tl.add([
                () => {
                    if (xBombSymbol.parent) {
                        xBombSymbol.parent.addChild(xBombSymbol);
                    }
                },
                // xBombSymbol.getStateAnimation(XBombStates.TRIGGER)
                xBombSymbol.playXBombExplodeAnimation(XBombStates.TRIGGER)
            ]);

            featureTl.add([
                tl,
                () => {
                    Game.soundPlayer.playSound(Sound.XB_EXPLODE, 1);
                }
            ], (0.2 * idx));
        });


        featureTl.addLabel("doHighlight");

        featureTl.add(() => {
            Game.soundPlayer.playSound(Sound.ATTACK_HIGHLIGHT, 1)
        }, "doHighlight");

        xBombs.forEach((xBomb: IFeatureData) => {
            featureTl.add([
                Game.showExplodePatternHighlighterOnSymbols(xBomb.reelId - 1, 0, Game.ACTIVE_ROWS_NUM),
                Game.showExplodePatternHighlighterOnSymbols(xBomb.reelId, 0, Game.ACTIVE_ROWS_NUM),
                Game.showExplodePatternHighlighterOnSymbols(xBomb.reelId + 1, 0, Game.ACTIVE_ROWS_NUM)
            ], "doHighlight");
        });

        featureTl.addLabel("doExplosion");

        xBombs.forEach((xBomb: IFeatureData) => {
            Game.updateSurprisedMonstersInExplosion(xBomb.reelId - 1, 0, Game.ACTIVE_ROWS_NUM),
            Game.updateSurprisedMonstersInExplosion(xBomb.reelId, 0, Game.ACTIVE_ROWS_NUM),
            Game.updateSurprisedMonstersInExplosion(xBomb.reelId + 1, 0, Game.ACTIVE_ROWS_NUM);
        });

        xBombs.forEach((xBomb: IFeatureData) => {
            const xBombSymbol: Symbol = Game.reelsView.reelModels[xBomb.reelId].getSymbolAt(xBomb.rowId, "XB");
            xBombSymbol.isRemoved = true;

            featureTl.add([
                Game.explodeSymbols(xBomb.reelId - 1, 0, Game.ACTIVE_ROWS_NUM),
                Game.explodeSymbols(xBomb.reelId, 0, Game.ACTIVE_ROWS_NUM),
                Game.explodeSymbols(xBomb.reelId + 1, 0, Game.ACTIVE_ROWS_NUM),
                xBombSymbol.playXBombExplodeAnimation(XBombStates.EXPLODE)
            ], "doExplosion");

            featureTl.add(Game.symbolFloors.showExplosionMark(xBomb.reelId, xBomb.rowId), "<0.2");

            featureTl.add(() => {
                if (xBombSymbol && xBombSymbol.parent) {
                    xBombSymbol.parent.removeChild(xBombSymbol);
                }
            });
        });

        featureTl.add(()=>{
            Game.shakeScreen()
        }, "doExplosion");

        xBombs.forEach(() => {
            featureTl.add(Game.multiplier.updateMultiplier(1, true));
        });
    }

    private skip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
        Game.soundPlayer.stopSound(Sound.XB_EXPLODE);
    }
}